import TitleAnimation from '@/components/ui/title-animation'

export default {
  name: 'case-link-animation',
  data () {
    return {
      needIntersection: true
    }
  },
  components: {
    TitleAnimation
  },
  props: {
    delay: 0,
    image: String,
    client: String,
    title: String,
    subtitle: String,
    projextType: String,
    to: String
  },
  mounted () {
    this.$el._show = this.show.bind(this)
    this.$el._hide = this.hide.bind(this)
    this.$el._component = this
  },
  methods: {
    show () {
      this.$el.classList.remove('hidden')
    },
    hide (up = true) {
      this.$el.classList.add('hidden')
    }
  }
}
